<h1 class="typography-title flex items-center gap-8">
  <svg-icon
    class="flex items-center justify-center s-16"
    src="assets/icons/games/games.svg"
  />
  Games
</h1>
<ul class="games w-full h-full">
  @for (game of games(); track $index) {
  <li class="game black-third-wrapper">
    <div class="game--badge left yellow">
      <div class="game--badge__wrapper">
        <svg-icon
          class="flex items-center justify-center s-16"
          [src]="game.icon"
        />
        {{ game.name }}
      </div>
    </div>
    @if (game.isNew) {
    <div class="game--badge right green">
      <div class="game--badge__wrapper">New</div>
    </div>
    }
    <a [routerLink]="game.link" class="w-full h-full">
      <img [src]="game.banner" [alt]="game.name" loading="lazy" />
    </a>
  </li>
  }
</ul>
